exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unread[data-v-108525cf] {\n   background-color: #ccc6c9 !important;\n}\n", ""]);

// exports
